// Common options object used for most Tabulation table components

interface DefaultSCTabulatorOptions {
    downloadDataFormatter: (data: any) => any;
    downloadReady: (fileContents: any, blob: any) => any;
    tableBuilt: () => void;
};

interface TabulatorOptionsWithMovableColumns extends DefaultSCTabulatorOptions {
    paginationSize?: number;
    paginationSizeSelector?: number[];
    pagination: boolean | string;
    movableColumns: boolean;
    persistenceID: string;
    // persistentLayout: boolean;
    // This is the new version of persistentLayout, we were already doing it
    // Keeping the persistentLayout as a fallback just in case
    persistence: {columns: boolean | string[]};
};

const SCTabulatorCommonOptions: DefaultSCTabulatorOptions = {
    // These functions must be implemented in options in order to make Tabulator's
    // download functionality work. See https://github.com/ngduc/react-tabulator/issues/76
    downloadDataFormatter: (data) => data,
    downloadReady: (fileContents, blob) => blob,
    /*
        TODO: we're using this callback to fix a couple of minor a11y issues that might be fixed by updating
        react-tabulator to a version which implements tabulator 5+. But that's a big lift, thus the bandaid.
    */
    tableBuilt: () => {
        // DNDA-1406: Table headers are missing required parent role (row)
        const headers = document.querySelectorAll('.tabulator-header');
        headers.forEach(header => {
            header.setAttribute('role', 'row');
        });

        // DNDA-1411: Grouped columns use invalid role "columngroup" and invalid attribute "aria-title"
        const groups = document.querySelectorAll('.tabulator-col.tabulator-col-group[role="columngroup"]');
        groups.forEach(group => {
            const title = group.getAttribute('aria-title');
            group.removeAttribute('aria-title');
            if (title) {
                group.setAttribute('aria-label', title);
            }
            group.setAttribute('role', 'columnheader');
        });
    },
    // TODO: Need to update to tabulator 5 for this to work. Test once that's done.
    // Set default values for all columns
    // columnDefaults: {
    //     accessor: (value, data, type, params, column) => {
    //         console.log('accessor', value, data, type, params, column);
    //         return value ?? '';
    //     }
    // },
};

export const options = (persistenceID: string, movableColumns: boolean = true, hasPagination: boolean | string = "local") => {

    var newOptions: TabulatorOptionsWithMovableColumns = {
        ...SCTabulatorCommonOptions,
        pagination: hasPagination,
        movableColumns: movableColumns,
        persistenceID: persistenceID,
        // persistentLayout: true,
        // Custom persistence, persisting the width causes strangeness when changing viewports on the same device
        // see https://tabulator.info/docs/4.9/persist
        persistence: {columns: ['visible', 'frozen']},
    };

    if (hasPagination === 'local') {
        newOptions.paginationSize = 25;
        newOptions.paginationSizeSelector = [25, 50, 100];
    }

    return newOptions;
};

export default options;